import { render, staticRenderFns } from "./MPPIPremiumBreakdownDialog.vue?vue&type=template&id=679daebb&scoped=true&"
import script from "./MPPIPremiumBreakdownDialog.vue?vue&type=script&lang=js&"
export * from "./MPPIPremiumBreakdownDialog.vue?vue&type=script&lang=js&"
import style0 from "./MPPIPremiumBreakdownDialog.vue?vue&type=style&index=0&id=679daebb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679daebb",
  null
  
)

export default component.exports